import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";

function ExpRow({
  item,
  index,
  isOpen,
  open,
  close,
  isTouch,
  isNavigating
}) {
  const {cursor} = useCursor()
  return (
    <motion.div
    {...cursor(CURSORS.image)}
      layout
      onMouseEnter={() => {
        if (!isTouch && !isNavigating) {
          open();
        }
      }}

      onMouseLeave={() => {
        if (!isTouch && !isNavigating) {
          close();
        }
      }}
      onClick={() => {
        if (isTouch && !isNavigating) {
          isOpen ? close() : open();
        }
      }}
      transition={{
        layout: {
          duration: 0.65,
          ease: [0.22, 1, 0.36, 1],
        },
      }}
      className={`-mx-px cursor-pointer overflow-hidden rounded-b-[50px] border-x border-b border-white sm:rounded-b-[65px] md:rounded-b-[80px] lg:rounded-b-[100px] ${isOpen ? "bg-white" : "bg-black"}`}
    >
      {/* HEADER */}

      <div className="flex justify-center px-5 py-10 sm:px-8 sm:py-12 md:px-10 md:py-14">
        <motion.h2
          layout
          transition={{
            layout: {
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1],
            },
          }}
          className={`font-minecraft text-[clamp(1.1rem,4vw,2rem)] font-bold uppercase ${index !== 0 ? "mt-8 sm:mt-12 md:mt-16 lg:mt-20" : "mt-0"} ${isOpen ? "tracking-[5px] text-black sm:tracking-[8px] md:tracking-[12px]" : "tracking-[2px] text-white sm:tracking-[3px] md:tracking-[4px]"}`}
        >
          {item.title}
        </motion.h2>
      </div>

      {/* CONTENT */}

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              height: {
                duration: 0.65,
                ease: [0.22, 1, 0.36, 1],
              },
              opacity: {
                duration: 0.3,
                ease: "easeOut",
              },
            }}
            className="overflow-hidden"
          >
            <div className="px-5 pb-12 sm:px-8 sm:pb-14 md:px-10 md:pb-16">



              {/* Description */}
              <motion.p
                initial={{ y: 15, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{
                  duration: 0.4,
                  delay: 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="mx-auto max-w-3xl text-center font-['Space_Mono'] text-[10px] leading-5 md:leading-7 text-black/70 sm:text-base sm:leading-8"
              >
                {item.desc}
              </motion.p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default ExpRow;